module.exports = __webpack_public_path__ + "static/media/car-dent.0ea2475f.png";